import useTranslationMarketing from './useTranslationMarketing';

export function useNuvemMarketingPlans() {
  const t = useTranslationMarketing('nuvemMarketing');

  const freePlan = [
    {
      feature: t('plansSection.plans.free.features.feature1'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.free.features.feature2'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.free.features.feature3'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.free.features.feature4'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.free.features.feature5'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.free.features.feature6'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.free.features.feature7'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.free.features.feature8'),
      disabled: false,
    },
    { feature: t('plansSection.plans.free.features.feature9'), disabled: true },
    {
      feature: t('plansSection.plans.free.features.feature10'),
      disabled: true,
    },
  ];

  const monthlyPlan = [
    {
      feature: t('plansSection.plans.monthly.features.feature1'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature2'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature3'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature4'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature5'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature6'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature7'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature8'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature9'),
      disabled: false,
    },
    {
      feature: t('plansSection.plans.monthly.features.feature10'),
      disabled: false,
    },
  ];

  return {
    freePlan,
    monthlyPlan,
  };
}
